import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';

import NavBar from './components/NavBar';
import About from './components/About';
import News from './components/News';
import Publications from './components/Publications';
import { ResearchExperience, IndustryExperience } from './components/Experience';
import Teaching from './components/Teaching';
import Footer from './components/Footer';

const theme = createTheme({
  palette: {
    primary: { main: '#8C1515' },
    background: { default: '#ffffff', paper: '#ffffff' },
    text: { primary: '#1a1a1a', secondary: '#5f6368' },
    divider: '#e6e6e6',
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: '"Geist", "Helvetica", "Arial", sans-serif',
    h3: { fontWeight: 700, fontSize: '2.25rem', letterSpacing: '-0.02em' },
    h4: { fontWeight: 700, fontSize: '1.5rem', letterSpacing: '-0.01em' },
    h6: { fontWeight: 600, fontSize: '1.02rem', lineHeight: 1.4 },
    body1: { fontSize: '1rem', lineHeight: 1.7 },
    body2: { fontSize: '0.92rem', lineHeight: 1.6 },
    button: { textTransform: 'none', fontWeight: 500 },
  },
  components: {
    MuiLink: {
      defaultProps: { underline: 'hover' },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <NavBar />
      <Box component="main" sx={{ maxWidth: 880, mx: 'auto', px: { xs: 2.5, md: 3 } }}>
        <About />
        <News />
        <Publications />
        <ResearchExperience />
        <IndustryExperience />
        <Teaching />
      </Box>
      <Footer />
    </ThemeProvider>
  );
}

export default App;
